import React, { useEffect, useRef, useState } from "react";
import {
  Container,
  Row,
  Col,
  Nav,
  Navbar,
  Form,
  Button,
  Table,
  Card,
  InputGroup,
} from "react-bootstrap";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Dropdown from "react-bootstrap/Dropdown";
import Offcanvas from "react-bootstrap/Offcanvas";
// import "./componentCss/dashboard.css";
import "../css/dashboard.css";
import { FaRegEye } from "react-icons/fa";

import { Link, useNavigate } from "react-router-dom";

import Appsidebar from "../../Appsidebar";
// import Dashboardheader from "./dashboardheader";
// import Sidebar from "./sidebar";
import Header from "../../Header";
import { AiFillInfoCircle } from "react-icons/ai";

// import "./componentCss/sidebar.css";
import "../css/appsidebar.css";
// import "../css/mobileappsidebar.css";
import "../css/mobileappsidebar.css";
import { FiChevronDown } from "react-icons/fi";
import { IoChevronDown } from "react-icons/io5";
import { IoMdTime } from "react-icons/io";
import { PiArrowUpFill } from "react-icons/pi";
import { RiArrowDownFill } from "react-icons/ri";
import { createChart, PriceScaleMode, ColorType } from "lightweight-charts";
// import  Tooltip  from 'react-tooltip'
// import Dashboardfooter from "./dashboardfooter";
import Dashboardfooter from "../../Pages/Dashboardfooter";
import Mobileappsidebar from "../../Mobileappsidebar";
// import { ChartComponent } from "../ChartComponent";
import {
  changePassword,
  getInfiChartData,
  getInfiPoolBalancetData,
} from "../../../services/apiServices";
// import "./componentCss/dashboardfooter.css";
import {
  FEE_SYMBOL,
  INFI_CONTRACT,
  INFI_DECIMAL,
  LIQUIDITY_CONTRACT,
  TOKEN_A,
  TOKEN_B,
  USDT_CONTRACT,
  USDT_DECIMAL,
} from "../../Web3/web3Config";
import { BloackchainGetTokenBalance } from "../../Web3/SwapConnector";
import { Success, Warning } from "../../../utils/errors";
import {
  initializeUseSelector,
  useSelector,
} from "react-redux/es/hooks/useSelector";
import Web3ModalProvider from "../../Pages/Presale/Connectwallet/Web3ModalProvider";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
// import Tooltip from 'react-bootstrap/Tooltip';
import Tooltip from "react-bootstrap/Tooltip";
import config from "../../../config";
// import Button from 'react-bootstrap/Button';

// import Header from '../../Header';

const Profilechangepassword = (props) => {
  const [poolBalanceData, setPoolBalanceData] = useState({});
  // const [connectWalletNow, setConnectWalletNow] = useState(false);
  const [connectWalletNow, setConnectWalletNow] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmpassword, setconfirmPassword] = useState("");
  const [oldPassword, setoldpassword] = useState("");
  const navigate = useNavigate();
  const [showpass, setshowpass] = useState(false);
  const [showoldpass, setshowoldpass] = useState(false);
  const [confirmshowpass, setconfirmshowpass] = useState(false);

  const loginDetails = useSelector((state) => state.auth.LoginDetails);
  const passwordRef = useRef(null);
  const confirmPasswordRef = useRef(null);
  const oldPasswordRef = useRef(null);
  useEffect(() => {}, []);

  const showpasswordfunc = (e) => {
    console.log(e, "asdf");
    if (e == 1) {
        setshowoldpass(!showoldpass);
    } else if (e == 2) {
      setshowpass(!showpass);
    } else if (e == 3) {
      setconfirmshowpass(!confirmshowpass);
    }
  };

  const submitForm = async (values) => {
    // alert(1);
    try {
      if (password != confirmpassword) {
        Warning("Password do not match");
        return;
      }
      if (!password || !confirmpassword || !oldPassword) {
        Warning("Please enter required fields");
        return;
      }
      let payload = {
        oldPassword: oldPassword,
        newPassword: password,
      };
      let res = await changePassword(payload, loginDetails.accessToken);

      if (res.data.status) {
        passwordRef.current.value = "";
        confirmPasswordRef.current.value = "";
        oldPasswordRef.current.value = "";
        setPassword("");
        setconfirmPassword("");
        setoldpassword("");
        Success("Password updated successfully");
        return;
      } else {
        Warning(res.data.message);
        return;
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (Object.keys(loginDetails).length==0){
      navigate(`${config.baseurl}login`);
    }
  }, [loginDetails])

  const inputhandler = (e) => {
    if (e.target.name == "password") {
      setPassword(e.target.value);
    } else if (e.target.name == "confirmpassword") {
      setconfirmPassword(e.target.value);
    } else if (e.target.name == "oldPassword") {
      setoldpassword(e.target.value);
    }
  };

  return (
    <>
    <div className="dashboard">
      {/* <Dashboardheader /> */}

      <Header
        connectWalletNow={connectWalletNow}
        setconnectWalletNow={setConnectWalletNow}
      />

      {/* <Dashboardheader /> */}

      <div className="wrapper">
        <Appsidebar />
        {/* <Mobileappsidebar/> */}
        <div id="content" className='position-relative'>
          <Container fluid className="pt-4">
            <Row>
              <Col lg={12} md={12} sm={12} className="mb-4">
                <div className="profile_sec">
                  <Row className="justify-content-center">
                    <Col lg={12} md={12} className="mx-auto">
                      <div className="py-4 px-4">
                        <Card className="cardBox ExchangeForm ">
                          <Row className="justify-content-center">
                            <Col lg={5} md={5} xs={12} className="mx-auto">
                              <div className="text-center formheadbox">
                                <h2 className="text-primary fw-bold mb-1">
                                  Change Password
                                </h2>
                              </div>
                              <div className="formDiv mt-3">
                                <div className="input-field fieldbox px-0 mb-3">
                                  <InputGroup className=" theme-input">
                                    <Form.Control
                                      type={`${
                                        showoldpass ? "name" : "password"
                                      }`}
                                      placeholder="Old Password"
                                      aria-label="Password"
                                      aria-describedby="basic-addon1"
                                      name="oldPassword"
                                      onChange={inputhandler}
                                      className="py-2 "
                                      ref={oldPasswordRef}
                                    />
                                    <span
                                      className="me-3"
                                      onClick={() => showpasswordfunc(1)}
                                    >
                                      <FaRegEye className="eyeIcon" />
                                    </span>
                                  </InputGroup>
                                </div>

                                <div className="input-field fieldbox px-0 mb-3">
                                  <InputGroup className=" theme-input">
                                    <Form.Control
                                      type={`${showpass ? "name" : "password"}`}
                                      placeholder="New Password"
                                      aria-label="Password"
                                      aria-describedby="basic-addon1"
                                      name="password"
                                      onChange={inputhandler}
                                      ref={passwordRef}
                                      className="py-2 "
                                    />
                                    <span
                                      className="me-3"
                                      onClick={() => showpasswordfunc(2)}
                                    >
                                      <FaRegEye className="eyeIcon" />
                                    </span>
                                  </InputGroup>
                                </div>

                                <div className="input-field fieldbox px-0 mb-3">
                                  <InputGroup className=" theme-input">
                                    <Form.Control
                                      type={`${
                                        confirmshowpass ? "name" : "password"
                                      }`}
                                      placeholder="Confirm Password"
                                      aria-label="Password"
                                      aria-describedby="basic-addon1"
                                      name="confirmpassword"
                                      className="py-2 "
                                      onChange={inputhandler}
                                      ref={confirmPasswordRef}
                                    />
                                    <span
                                      className="me-3"
                                      onClick={() => showpasswordfunc(3)}
                                    >
                                      <FaRegEye className="eyeIcon" />
                                    </span>
                                  </InputGroup>
                                </div>

                                <div className="text-center mt-3 ">
                                  <Button
                                    variant="custombtn2"
                                    className="py-2 w-100 fw-bold"
                                    type="submit"
                                    onClick={submitForm}
                                  >
                                    Submit
                                  </Button>
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </Card>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
      </div>
    </>
  );
};

export default Profilechangepassword;
